module.exports = __webpack_public_path__ + "img/aniversario7.6aa04a2a.jpg";